import React from 'react';
import {MDBContainer,} from "mdb-react-ui-kit";

const patientpaymentportal = () => {
    return (
        <MDBContainer fluid className="p-0">
        <div className="container py-5">
            <div className="row">
              <div className="col-12">
                  <div className="section-title mb-4 pb-2">
                      <h1 className="title mb-4 display-heading AcerhealthTextPurple text-center fomtsizetest" style={{fontFamily:'Lora, serif'}}>Patient Statements & Payment Portal</h1>
                      <p className="para-desc mx-auto mb-0" style={{fontSize:'20px',fontFamily: 'Alegreya Sans',fontWeight:'500' ,textAlign: 'justify'}}>
                       Technology has significantly enhanced capabilities across the healthcare industry, and we leverage these advancements to simplify patient payments and improve collections. Our <b>Patient Statements
                        & Payment Portal </b>enables patients to pay over the phone, receive electronic statements via email, and get text message reminders about outstanding statement balances. This modern, user-friendly 
                        approach strengthens <b>revenue cycle management,</b> supports efficient 
                         <a
                            href="https://acerhealth.com/services/medical-billing-services"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
               medical billing services,
                        </a>  
                        and complements your <b>medical billing outsourcing </b>strategy by reducing administrative burden and accelerating cash flow.</p>
                  </div>
              </div>
          </div>
        </div>    
        </MDBContainer>
    );
};
export default patientpaymentportal;